// Copyright (c) Docugami, Inc. All rights reserved.

import { DocSourceId } from "components/myContentExplorer/ExplorerTypes";
import { IconDescriptor, IconRenderer } from "components/work_path/IconRenderer";
import { dgIconNames } from "hooks/dgIcons";
import { ProviderId } from "networking/StorageProviders";

export function getProviderFriendlyName(id: ProviderId) {
    switch (id) {
        case ProviderId.OneDrive:
            return "OneDrive";
        case ProviderId.SharePoint:
            return "SharePoint"
        case ProviderId.Box:
            return "Box"
        case ProviderId.Dropbox:
            return "Dropbox"
    }
}

export function getIconForStorageProvider(id: ProviderId, width: number, height: number, containerWidth?: number, containerHeight?: number): JSX.Element {
    return <IconRenderer source={getIconDescriptorForStorageProvider(id)} width={width} height={height} containerWidth={containerWidth} containerHeight={containerHeight} />
}

export function getIconDescriptorForStorageProvider(providerId: ProviderId): IconDescriptor {
    switch (providerId) {
        case ProviderId.OneDrive:
            return {
                name: dgIconNames.DgOneDrive,
                width: 1,
                height: .64
            };

        case ProviderId.SharePoint:
            return {
                name: dgIconNames.DgSharePoint,
                width: 1,
                height: .9
            };

        case ProviderId.Box:
            return {
                name: dgIconNames.DgBoxLogo,
                width: 1,
                height: 1
            };

        case ProviderId.Dropbox:
            return {
                name: dgIconNames.DgDropboxLogo,
                width: 1,
                height: .93
            };

        default:
            throw new Error('Unsupported provider ID');
    }
}

export function getProviderRootPath(providerId: ProviderId | null) {
    return !!providerId ? `.remote/${providerId}/` : ''
}

export function getProviderIdFromPath(path?: string): ProviderId | undefined {
    if (!path || !path.startsWith('.remote')) {
        return;
    }

    const parts = path.split('/');
    if (parts.length < 2) {
        return;
    }

    // Return the provider id that case insensitively matches the providerId in the given path
    return Object.keys(ProviderId).find(id => id.toLowerCase().localeCompare(parts[1].toLowerCase()) === 0) as ProviderId;
}

export function getProviderForDocSource(docSourceId: DocSourceId): ProviderId | undefined {
    switch (docSourceId) {
        case DocSourceId.OneDrive:
            return ProviderId.OneDrive;
        case DocSourceId.SharePoint:
            return ProviderId.SharePoint;
        case DocSourceId.Box:
            return ProviderId.Box;
        case DocSourceId.Dropbox:
            return ProviderId.Dropbox;
        default:
            return undefined;
    }
}

export function getLabelForDocSource(docSourceId: DocSourceId): string {
    switch (docSourceId) {
        case DocSourceId.OneDrive:
            return getProviderFriendlyName(ProviderId.OneDrive);
        case DocSourceId.SharePoint:
            return getProviderFriendlyName(ProviderId.SharePoint);
        case DocSourceId.Box:
            return getProviderFriendlyName(ProviderId.Box);
        case DocSourceId.Dropbox:
            return getProviderFriendlyName(ProviderId.Dropbox);
        default:
            return "Uploaded Docs";
    }
}